import { Headers } from '@egw/components'
import { DebitCardPage } from '@egw/features-account'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const CheckingAccountDebitCardPage: FC = () => {
  const { t } = useTranslation()

  const { alias } = useParams<{ alias: string }>()

  if (!alias) {
    return null
  }
  return (
    <Layout>
      <Headers title={t('pages.checking.title')} />
      <DebitCardPage alias={alias} />
    </Layout>
  )
}
